/**
 * ProUpgrade — legacy Stripe upgrade surface.
 *
 * Gamma Trade is now free forever, so every "upgrade" entry point has been
 * neutralised. We keep zero-behaviour exports here so existing call sites
 * (`ProUpgradeModal`, `ProUpgradeButton`, `useBillingReturnHandler`) don't
 * need to be edited individually. Feel free to delete these imports as the
 * codebase is refactored.
 */
export const ProUpgradeModal = () => null;
export const ProUpgradeButton = () => null;
export const useBillingReturnHandler = () => {};
export default ProUpgradeButton;
